import React from 'react';

import { Alert, Flex, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';
import { stringToBoolean } from '@app/services/stringToBoolean';
import { AccessDenied } from '@components/AccessDenied';
import { Paper } from '@components/Paper';

interface IProps {
  children: React.ReactNode;
}

export const EpdAccess: React.FC<IProps> = ({ children }) => {
  const session = useLocalSelector((state) => state.currentSession);
  const spaceT = useTranslation(NSKeys.spaceSettings);
  if (!stringToBoolean(process.env.REACT_APP_FEATURE_EPD)) return <AccessDenied />;
  if (!session.ordersContext || !session.data)
    return (
      <Flex justify="center" style={{ padding: 48 }}>
        <Spin />
      </Flex>
    );
  if (!session.ordersContext.scope.$permissions.view_epd) return <AccessDenied />;
  if (session.data.scope.is_sandbox)
    return (
      <Paper style={{ margin: 24, padding: 24 }}>
        <Alert type="warning" showIcon title={spaceT.t('organization.sandboxTitle')} />
      </Paper>
    );
  return <>{children}</>;
};
